var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isShowLoading)?_c('div',{staticClass:"loadingBox"},[_c('img',{attrs:{"src":require("../../assets/images/loading.gif"),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }